const Events = {
		Productions : {
			RECEIVE: "RECEIVE_LIST_PRODUCTIONS",
			REQUEST:"REQUEST_LIST_PRODUCTIONS"
		},
		Settings : {
			PRODUCTION_DEFAULT_REQUEST:"PRODUCTION_DEFAULT_REQUEST",
			PRODUCTION_DEFAULT_RECEIVE:"PRODUCTION_DEFAULT_RECEIVE",
			TAB_DEFAULT_REQUEST: "TAB_DEFAULT_REQUEST",
			TAB_DEFAULT_RECEIVE: "TAB_DEFAULT_RECEIVE"
		},
		Series : {
			SUMMARY_RECEIVE : "SUMMARY_RECEIVE",
			TICKET_REVENUE_GOAL : "TICKET_REVENUE_GOAL",
			TICKET_REVENUE : "TICKET_REVENUE",
			TICKET_QUANTITY_SOLD_GOAL : "TICKET_QUANTITY_SOLD_GOAL",
			TICKET_QUANTITY_SOLD : "TICKET_QUANTITY_SOLD",
			SALES_REVENUE_RECEIVE : "SALES_REVENUE_RECEIVE",
			TICKET_BREAKDOWN_SALES_RECEIVE : "TICKET_BREAKDOWN_SALES_RECEIVE",
			DNDTABLE_DATA_RECEIVE: "DNDTABLE_DATA_RECIEVE",
			DNDTABLE_DATA_ADD : "DNDTABLE_DATA_ADD",
      DNDTABLE_DATA_UPDATE : "DNDTABLE_DATA_UPDATE",
      DNDTABLE_DATA_DELETE : "DNDTABLE_DATA_DELETE",
			FEE_INCLUSION_RECEIVE: "FEE_INCLUSION_RECEIVE"
		},
		ErrorHandler : {
			ERROR : "ERROR",
			CLEAR_ERROR : "CLEAR_ERROR"
		}
}

export default Events;



// WEBPACK FOOTER //
// ./src/actions/events.js